import { StateObservable } from 'redux-observable'

import { IStoreState } from '../../IStoreState'
import { requestDashboard } from '../../actions/dashboard/DashboardAction'
import { setNotification } from '../../actions/notifications/NotificationsAction'
import { Notification } from '../../../../entities/notification/Notification'
import { IntlService } from '../../../intl/IntlService'
import toastMessages from '../../../intl/ToastMessages'

/**
 * The actions every printer-driving epic dispatches when a print fails.
 *
 * Kept out of the epics module so they can be unit tested: importing that module pulls
 * in the API client, the label repository singleton and the rest of the dashboard
 * graph, which is why the date bug these guard against shipped untested.
 */

/**
 * LabelRepository reports a failure only by rejecting, so an epic that catches without
 * notifying leaves the seller with no indication the label did not come out.
 */
export const printFailureNotification = (error: { message?: string }) =>
  setNotification(new Notification({
      id: `print-error-${Date.now()}`,
      text: IntlService.formatMessage(toastMessages.printError, {
          error: error.message || IntlService.formatMessage(toastMessages.printErrorUnknown),
      }),
  }))

/**
 * Re-fetches the day the seller is currently looking at.
 *
 * Deliberately state$.value.Dashboard.selectedDate and not new Date(), matching the
 * success path in mapSetDateToRequestDashboardEpic: REQUEST_DASHBOARD fetches whatever
 * date it is handed and never updates selectedDate, so new Date() would load today's
 * orders into a past day's columns while the date picker still showed that past day.
 */
export const refreshSelectedDay = (state$: StateObservable<IStoreState>) =>
  requestDashboard({
      date: state$.value.Dashboard.selectedDate,
      shouldResetOpenCycles: false,
  })
